/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { ASSETS_TABLE } from "../pages/ListedAssetsTable/graphql/listed-asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

const MODULE_NAME = "ListedAssetTableService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ListedAssetTableService {
    private static instance: ListedAssetTableService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): ListedAssetTableService {
        if (!ListedAssetTableService.instance) {
            ListedAssetTableService.instance = new ListedAssetTableService(props);
        }
        return ListedAssetTableService.instance;
    }

    async getListedAssetTable() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: ASSETS_TABLE,
                    variables: {
                        assetTableCriteria: {
                            state: "listed"
                        },
                        assetTableOffset: 0,
                        assetTableSize: 5000
                    },
                    fetchPolicy:'network-only'
                });
                log.success(MODULE_NAME, "getListedAssetTable: ", res);
                return res?.data?.assetTable;
            }
        } catch (err) {
        }
    }
}
